<script>
  import { _ as t } from "svelte-i18n";
  import { Link } from "svelte-routing";

  import Button from "components/Button.svelte";
  import Input from "components/Input.svelte";
  import Errors from "components/GraphQLErrors.svelte";
  import { currentLang } from "stores.js";

  export let onLogin;
  export let onClose;
  export let loginUser;
  export let forgotPassword;

  let email;
  let password;

  let recoveryPasswordSuccess = false;
  let recoveryPasswordFailure = false;

  let errorMessages = [];

  const resetErrors = () => {
    errorMessages = [];
  };

  const handleLogin = () => {
    loginUser(email, password)
      .then(({ data }) => {
        onLogin(data.loginUser);
      })
      .catch((error) => {
        console.log(error);
        errorMessages = error.graphQLErrors;
        console.log(errorMessages);
      });
  };

  const handleForgotPassword = () => {
    forgotPassword(email, $currentLang)
      .then(({ data }) => {
        if (data.forgotPassword) {
          recoveryPasswordSuccess = true;
        } else {
          recoveryPasswordFailure = true;
        }
      })
      .catch((error) => {
        console.log(error);
        errorMessages = error.graphQLErrors;
        console.log(errorMessages);
      });
  };

  const close = () => {
    onClose();
  };

  $: validForm = email && email.length > 0;
</script>

{#if recoveryPasswordSuccess}
  <h1>{$t("passwordRecovery")}</h1>
  <div class="description">
    {$t("passwordRecoveryDescription", { values: { email: email } })}
  </div>
  <Button on:click={close}>{$t("close")}</Button>
{:else if recoveryPasswordFailure}
  <h1>{$t("passwordRecovery")}</h1>
  <div class="description-error">
    {$t("passwordRecoveryNoUserDescription", { values: { email: email } })}
  </div>
  <Button on:click={close}>{$t("close")}</Button>
{:else}
  <h1>{$t("login")}</h1>
  <Input
    on:change={resetErrors}
    bind:value={email}
    type="email"
    key="email"
    label={$t("registration.email")}
  />
  <Input
    on:change={resetErrors}
    bind:value={password}
    type="password"
    key="password"
    label={$t("registration.password")}
  />

  <Errors {errorMessages} />

  <div class="link">
    <Link to="/registration" on:click={close}>{$t("registerLink")}</Link>
  </div>

  <div class="button-wrapper">
    <Button secondary active={validForm} on:click={handleForgotPassword}
      >{$t("forgotPassword")}</Button
    >
    <Button active={validForm} on:click={handleLogin}>{$t("login")}</Button>
  </div>
{/if}

<style>
  h1 {
    font-weight: 300;
    font-size: 32px;
    margin: 0;
  }

  .link {
    margin-bottom: 24px;
  }

  .button-wrapper {
    display: flex;
    flex-direction: column-reverse;
    flex-wrap: wrap;
  }

  :global(.button-wrapper > button) {
    margin-top: 12px;
  }

  @media only screen and (min-width: 600px) {
    .button-wrapper {
      flex-direction: row;
      justify-content: space-between;
    }

    :global(.button-wrapper > button + button) {
      margin-left: 24px;
    }
  }

  .description {
    margin: 24px 0;
  }

  .description-error {
    margin: 24px 0;
    color: red;
  }
</style>
